import { ArrowUpIcon } from '@devsisters/wds-icons';
import { Button, cn } from '@devsisters/wds-react';

interface Props {
  className?: string;
}

function ToTop(props: Props) {
  const { className } = props;

  const handleClick = () => {
    window.scrollTo({ top: 0 });
  };

  return (
    <Button
      className={cn('h-12 w-12 bg-black/80 p-0 !text-white', className)}
      variant={'fill'}
      rounded
      color={'gray'}
      onClick={handleClick}
    >
      <ArrowUpIcon width={16} />
    </Button>
  );
}

export default ToTop;
